import React, { useEffect } from 'react';
import '../../styles/training.css';

export default function TrainingCompletePage() {
  const name = sessionStorage.getItem('training_name') || 'Employee';

  useEffect(() => {
    sessionStorage.removeItem('training_token');
    sessionStorage.removeItem('training_name');
    sessionStorage.removeItem('training_brand');
  }, []);

  return (
    <div className="tg-complete">
      <div className="tg-complete__card">
        <div className="tg-complete__icon">✓</div>
        <h1 className="tg-complete__title">Training Complete</h1>
        <p className="tg-complete__name">{name}</p>
        <p className="tg-complete__body">
          You have completed all 8 weeks of the AML Training Programme under Regulation 24
          of the Money Laundering Regulations 2017.
        </p>
        <p className="tg-complete__body">
          Your responses have been recorded and will be reviewed by your manager.
          A completion record has been added to the Regulation 24 evidence trail.
        </p>
        <p className="tg-complete__note">
          You may now close this window.
        </p>
      </div>
    </div>
  );
}
